<ul>
  @for (item of item.children; track item.id) {
    <li>
      <app-menu-item
        [contentTemplateRef]="contentTemplateRef"
        [item]="item"
        [nestedContentTemplateRef]="contentTemplateRef" />
    </li>
  }
</ul>
